"use client";
import { Menu, X } from "lucide-react";
import { useTranslations } from "next-intl";

type Props = {
  isOpen: boolean;
  toggleNavbar: () => void;
};

export default function MobileToggle({ isOpen, toggleNavbar }: Props) {
  const t = useTranslations("menuMobile");
  return (
    <button
      onClick={toggleNavbar}
      className="lg:hidden flex flex-col items-center justify-center gap-1 text-white z-[90] p-2 rounded-lg hover:bg-white/10 active:bg-white/20 transition-all duration-200"
    >
      <div className="relative w-6 h-6">
        {isOpen ? (
          <X className="h-6 w-6 animate-fade-in" />
        ) : (
          <Menu className="h-6 w-6 animate-fade-in" />
        )}
      </div>
      <span className="uppercase text-[10px] font-semibold tracking-wide">
        {isOpen ? t("close") : t("menu")}
      </span>
    </button>
  );
}
